import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type UserType = 'investor' | 'admin';

interface User {
    id: string;
    email: string;
    name: string;
    type: UserType;
}

interface AuthState {
    isAuthenticated: boolean;
    userType: UserType | null;
    user: User | null;
}

const initialState: AuthState = {
    isAuthenticated: false,
    userType: null,
    user: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login: (state, action: PayloadAction<{ userType: UserType; user?: User }>) => {
            state.isAuthenticated = true;
            state.userType = action.payload.userType;
            state.user = action.payload.user || null;
        },
        logout: (state) => {
            state.isAuthenticated = false;
            state.userType = null;
            state.user = null;
        },
        setUser: (state, action: PayloadAction<User>) => {
            state.user = action.payload;
        },
    },
});

export const { login, logout, setUser } = authSlice.actions;
export type { User };
export default authSlice.reducer;
